class Helper {
    // Get language url
    getLanguageUrl(linguise_switcher, lang)
    {
        if (this.isDemoMode(linguise_switcher)) {
            return '#';
        }

        if (linguise_switcher.is_joomla) {
            return this.fixTrailingSlashes(linguise_switcher, this.getJoomlaLanguageUrl(lang, linguise_switcher));
        } else if (linguise_switcher.is_wp) {
            return this.fixTrailingSlashes(linguise_switcher, this.getWpLanguageUrl(lang, linguise_switcher));
        } else {
            return this.fixTrailingSlashes(linguise_switcher, this.getOtherCMSUrl(linguise_switcher, lang));
        }
    }

    getOtherCMSUrl(linguise_switcher, lang)
    {
        if (linguise_switcher.domain_structure === 'subdomains') {
            return this.getUrlForSubDomains(linguise_switcher, lang);
        } else {
            return this.getUrlForSubFolders(linguise_switcher, lang);
        }
    }

    getWpLanguageUrl(language, config) {
        // Try to find the alternate
        const alternate = document.querySelector('link[rel="alternate"][hreflang="' + language + '"]');
        if (alternate !== null && alternate.href !== undefined) {
            return alternate.href;
        }

        return config.scheme + '//' + config.host + (config.base ? config.base : '') + (language === config.default_language ? '' : '/' + language) + config.original_path + config.trailing_slashes + (config.search ? config.search : '');
    }

    getJoomlaLanguageUrl(language, config) {
        // Try to find the alternate
        const alternate = document.querySelector('link[rel="alternate"][hreflang="' + language + '"]');
        if (alternate !== null && alternate.href !== undefined) {
            return alternate.href;
        }

        const joomla_languages = config.linguise_configs?.joomla_languages || [];
        if (joomla_languages.indexOf(language) !== -1 && language !== config.default_language) {
            // This language is handled by Joomla
            return `${config.scheme}//${config.host + (config.base ? config.base : '') + '/' + language + config.trailing_slashes}`;
        }
        return `${config.scheme}//${config.host + (config.base ? config.base : '') + (language === config.default_language ? '' : '/' + language) + config.original_path + config.trailing_slashes + (config.search ? config.search : '')}`;
    }

    fixTrailingSlashes(linguise_switcher, url)
    {
        const parsed_url = new URL(url);
        // If the url is the root, return it
        if (parsed_url.pathname === '/') {
            return parsed_url.toString();
        }
        // Append or remove trailing slashes depending on the current location URL
        parsed_url.pathname = parsed_url.pathname.replace(/\/+$/, '');
        parsed_url.pathname = parsed_url.pathname + linguise_switcher.trailing_slashes;
        return parsed_url.toString();
    }

    getUrlForSubFolders(linguise_switcher, lang)
    {
        if (linguise_switcher.url_translations && linguise_switcher.url_translations[lang] !== undefined) {
            // We have a translated url
            return linguise_switcher.domain + (lang === linguise_switcher.default_language ? '' : '/' + lang) + linguise_switcher.url_translations[lang];
        } else if (linguise_switcher.url_translations && linguise_switcher.url_translations[linguise_switcher.default_language] !== undefined) {
            // We have a non translated url for default language
            return linguise_switcher.domain + (lang === linguise_switcher.default_language ? '' : '/' + lang) + linguise_switcher.url_translations[linguise_switcher.default_language];
        } else {
            // We have no translation
            return linguise_switcher.domain + (lang === linguise_switcher.default_language ? '' : '/' + lang) + linguise_switcher.path + linguise_switcher.search;
        }
    }

    getUrlForSubDomains(linguise_switcher, lang)
    {
        const domain = linguise_switcher.domain;
        // Get http:// or https://
        const protocol = domain.substring(0, domain.indexOf("//") + 2);
        // Get hostname, example linguise.com
        const languageCodes = linguise_switcher.available_languages.map(lang => lang.code); // [fr, de]
        let hostname = domain.replace(new RegExp(`(https?:\/\/(?:${languageCodes.join('|')})\\.|https?:\/\/)`, ""), "");
        if (lang !== linguise_switcher.default_language && hostname.startsWith('www.')) {
            hostname = hostname.substring(4);
        }
        if (linguise_switcher.url_translations && linguise_switcher.url_translations[lang] !== undefined) {
            // We have a translated url
            return protocol + (lang === linguise_switcher.default_language ? '' : lang + '.') + hostname + linguise_switcher.url_translations[lang];
        } else if (linguise_switcher.url_translations && linguise_switcher.url_translations[linguise_switcher.default_language] !== undefined) {
            // We have a non translated url for default language
            return protocol + (lang === linguise_switcher.default_language ? '' : lang + '.') + hostname + linguise_switcher.url_translations[linguise_switcher.default_language];
        } else {
            // We have no translation
            return protocol + (lang === linguise_switcher.default_language ? '' : lang + '.') + hostname + linguise_switcher.path + linguise_switcher.search;
        }
    }

    /**
     * Sort the languages
     * 
     * NOTE:
     * - There is a different between how Desktop and Mobile sort strings.
     * @param {import('./LinguiseSwitcher').default} linguise_switcher
     */
    sort(linguise_switcher)
    {
        if (linguise_switcher.is_joomla || linguise_switcher.is_wp) {
            // In WP/Joomla, we don't sort since they can be sorted manually.
            return;
        }

        linguise_switcher.available_languages.sort((a, b) => {
            if (a.code === linguise_switcher.default_language) {
                return -1;
            }
            if (b.code === linguise_switcher.default_language) {
                return 1;
            }
            return a.original_name < b.original_name;
        });
    }

    // Render Flag Class
    getFlagClass(language_settings, lang)
    {
        if (lang === 'en' && language_settings?.flag_en_type === 'en-gb') {
            return 'en_gb';
        } else if (lang === 'de' && language_settings?.flag_de_type === 'de-at') {
            return 'de_at';
        } else if (lang === 'es' && language_settings?.flag_es_type === 'es-mx') {
            return 'es_mx';
        } else if (lang === 'es' && language_settings?.flag_es_type === 'es-pu') {
            return 'es_pu';
        } else if (lang === 'pt' && language_settings?.flag_pt_type === 'pt-br') {
            return 'pt_br';
        } else if (lang === 'zh-tw' && language_settings?.flag_tw_type === 'zh-cn') {
            return 'zh-cn';
        }

        return lang;
    }

    // Render Flag
    renderFlag(language_settings, lang)
    {
        if (language_settings) {
            const {enabled_flag, flag_width, flag_shape, flag_border_radius} = language_settings;
            if (enabled_flag) {
                return `<span 
                        class="linguise_flags linguise_flag_${this.getFlagClass(language_settings, lang)} linguise_language_icon" 
                        style="width: ${flag_width + 'px'}; min-width: ${flag_width + 'px'};
                               height: ${(flag_shape === 'rectangular' ? flag_width / 1.7 : flag_width) + 'px'};
                               min-height: ${(flag_shape === 'rectangular' ? flag_width / 1.7 : flag_width) + 'px'};
                               border-radius: ${flag_shape === 'rectangular' ? flag_border_radius + 'px' : '50%'};">         
                    </span>`;
            }

            return '';
        } else {
            return `<span class="linguise_flags linguise_flag_${this.getFlagClass(language_settings, lang)} linguise_language_icon" style="width: 24px; height: 24px; border-radius: 50%"></span>`;
        }
    }

    // Render Language name
    renderLanguageName(language_settings, lang, name, originalName, isPopupItem = false)
    {
        if (language_settings) {
            if (language_settings.enabled_lang_short_name) {
                return `<span class="linguise_lang_name mr-10 ${isPopupItem ? 'popup_linguise_lang_name' : ''}">${lang.toUpperCase()}</span>`;
            } else if (language_settings.enabled_lang_name) {
                return `<span class="linguise_lang_name mr-10 ${isPopupItem ? 'popup_linguise_lang_name' : ''}">${language_settings.lang_name_display === 'en' ? name : originalName}</span>`;
            }

            return '';
        } else {
            return `<span class="linguise_lang_name popup_linguise_lang_name">${originalName}</span>`;
        }
    }

    // Render Language name
    colorAndHoverLanguageName(language_settings, elements, popupElements)
    {
        const flagShadColor = language_settings?.flag_shadow_color || '#eeeeee';
        const flagHoverShadColor = language_settings?.flag_hover_shadow_color || '#bfbfbf';
        const flagShadAlpha = language_settings?.flag_shadow_color_alpha ?? 1.0;
        const flagHoverShadColorAlpha = language_settings?.flag_hover_shadow_color_alpha ?? 1.0;

        const flagShadColorMixed = this.mixinColorAndAlpha(flagShadColor, this.clampAlpha(flagShadAlpha)) || flagShadColor;
        const flagHoverShadColorMixed = this.mixinColorAndAlpha(flagHoverShadColor, this.clampAlpha(flagHoverShadColorAlpha)) || flagHoverShadColor;

        const flagBoxShadow = `${(language_settings?.flag_shadow_h ?? 2) + 'px ' + (language_settings?.flag_shadow_v ?? 2) + 'px ' + (language_settings?.flag_shadow_blur ?? 12) + 'px ' + (language_settings?.flag_shadow_spread ?? 0) + 'px ' + flagShadColorMixed}`;
        const flagHoverBoxShadow = `${(language_settings?.flag_hover_shadow_h ?? 3) + 'px ' + (language_settings?.flag_hover_shadow_v ?? 3) + 'px ' + (language_settings?.flag_hover_shadow_blur ?? 6) + 'px ' + (language_settings?.flag_hover_shadow_spread ?? 0) + 'px ' + flagHoverShadColorMixed}`;

        /**
         * Apply styles to the element and flag
         * @param {HTMLSpanElement} element the element to apply styles
         * @param {HTMLSpanElement} flag the flag element
         * @param {string} color the color
         * @param {string} hoverColor the color on hover
         * @param {string} boxShadow the box shadow color
         * @param {string} hoverBoxShadow the box shadow color on hover
         */
        const applyStyles = (element, flag, color, hoverColor, boxShadow, hoverBoxShadow) => {
            element.style.color = color || '#000000';
            if (flag) {
                flag.style.boxShadow = boxShadow;
            }

            element.parentNode.addEventListener("mouseover", function () {
                element.style.color = hoverColor || '#000000';
                if (flag) {
                    flag.style.boxShadow = hoverBoxShadow;
                }
            });

            element.parentNode.addEventListener("mouseout", function () {
                element.style.color = color || '#000000';
                if (flag) {
                    flag.style.boxShadow = boxShadow;
                }
            });
        };

        Array.from(elements).forEach(function (element) {
            const flag = element.previousElementSibling;
            applyStyles(element, flag, language_settings?.language_name_color, language_settings?.language_name_hover_color, flagBoxShadow, flagHoverBoxShadow);
        });

        Array.from(popupElements).forEach(function (element) {
            const flag = element.previousElementSibling;
            applyStyles(element, flag, language_settings?.popup_language_name_color, language_settings?.popup_language_name_hover_color, flagBoxShadow, flagHoverBoxShadow);
        });
    }

    /**
     * Position the switcher
     * @param {HTMLElement} element the element to position
     * @param {string | null} type the type of switcher (dropdown or button)
     * @param {string | null} position the position
     */
    languagePosition(element, type, position)
    {
        /** @type {HTMLElement} */
        const linguiseSwitcher = element.querySelector('.linguise_switcher');
        /** @type {HTMLUListElement} */
        const dropdownSwitcherSub = element.querySelector('.linguise_switcher_sub');
        let cssText = '';
        switch (position) {
            case 'no': {
                break;
            }
            case 'top_left':
            case 'top_left_no_scroll': {
                cssText = 'position: fixed; top: 10px; left: 10px; z-index: 99999; background: #fff; border-radius: 0;';
                break;
            }
            case 'top_right':
            case 'top_right_no_scroll': {
                cssText = 'position: fixed; top: 10px; right: 10px;z-index: 99999; background: #fff; border-radius: 0;';
                break;
            }
            case 'bottom_left':
            case 'bottom_left_no_scroll': {
                cssText = 'position: fixed; bottom: 10px; left: 10px;z-index: 99999; background: #fff; border-radius: 0;';
                if (type === 'dropdown' && dropdownSwitcherSub) {
                    dropdownSwitcherSub.style.cssText = 'top: unset; bottom: 100%';
                }
                break;
            }
            case 'bottom_right':
            case 'bottom_right_no_scroll': {
                cssText = 'position: fixed; bottom: 10px; right: 10px;z-index: 99999; background: #fff; border-radius: 0;';
                if (type === 'dropdown' && dropdownSwitcherSub) {
                    dropdownSwitcherSub.style.cssText = 'top: unset; bottom: 100%';
                }
                break;
            }
            default:
                break;
        }

        if (linguiseSwitcher) { // to avoid any error
            linguiseSwitcher.style.cssText = cssText;
            if (['top_left_no_scroll','top_right_no_scroll', 'bottom_left_no_scroll', 'bottom_right_no_scroll'].includes(position)) {
                linguiseSwitcher.style.position = 'absolute';
            }
        }
    }

    /**
     * Check if we already injected flag for this element.
     * @param {HTMLElement} element the element
     * @returns {boolean}
     */
    isAlreadyInjected(element) {
        const htmlContent = element.innerHTML?.trim() || '';
        const isNotEmptyAndNotShortcode = htmlContent.length > 0 && htmlContent !== '[linguise]';
        return typeof element.getAttribute === 'function' && element.getAttribute('data-flag-ready') === '1' && isNotEmptyAndNotShortcode;
    }

    /**
     * Replace the element content and inject the flag.
     *
     * This process automate the clone -> inject process then the color and hover process
     * @param {HTMLElement} element The element to replace
     * @param {HTMLElement} flagElement The flag element
     * @param {any} language_settings The language settings
     */
    replaceAndPaintElement(element, flagElement, language_settings)
    {
        if (this.isAlreadyInjected(element)) {
            return;
        }

        element.innerHTML = '';
        /** @type {HTMLElement} */
        const cloneFlag = flagElement.cloneNode(true);
        cloneFlag.dataset.flagReady = '1';
        element.appendChild(cloneFlag);
        element.setAttribute('data-flag-ready', '1');

        // Language color and hover
        const elements = element.getElementsByClassName('linguise_lang_name');
        const popupElements = element.getElementsByClassName('popup_linguise_lang_name');
        this.colorAndHoverLanguageName(language_settings, elements, popupElements);
    }

    /**
     * Replace linguise shortcode to switcher
     *
     * @param {string} position where to append switcher
     * @param {HTMLElement} appendedElement the element to append
     * @param {import('./LinguiseSwitcher').default} linguise_switcher the switcher object
     */
    replaceLinguiseShortcodeToSwitcher(position, appendedElement, linguise_switcher)
    {
        const is_demo = this.isDemoMode(linguise_switcher);
        const previewContent = document.getElementById('dashboard-live-preview');
        const linguiseSwitcher = document.getElementsByClassName('linguise_switcher_root');
        const linguiseShortcodeElements = this.findElementWithShortcode('[linguise]');
        let has_been_replaced = false;

        if (previewContent) {
            // Language color and hover
            const elements = appendedElement.getElementsByClassName('linguise_lang_name');
            const popupElements = appendedElement.getElementsByClassName('popup_linguise_lang_name');
            this.colorAndHoverLanguageName(linguise_switcher.language_settings, elements, popupElements);
            // Switcher preview dashboard, this will be put in-place
            previewContent.appendChild(appendedElement);
            return;
        }

        // Shortcode [linguise] will always get replaced in-place
        if (linguiseShortcodeElements.length > 0) {
            Array.from(linguiseShortcodeElements).forEach(element => {
                this.replaceAndPaintElement(element, appendedElement, linguise_switcher.language_settings);
                has_been_replaced = true;
            });
        }

        /**
         * Switcher root that is used by:
         * - WP in [switcher] shortcode
         * - WP in menu
         * - Joomla in shortcode ({loadmodule mod_linguise})
         * - Joomla in menu
         */
        if (linguiseSwitcher.length > 0) {
            Array.from(linguiseSwitcher).forEach((element) => {
                // If menu -> do in-place position
                const is_menu = element.classList.contains('linguise_menu_root') || element.classList.contains('linguise_menu');

                this.replaceAndPaintElement(element, appendedElement, linguise_switcher.language_settings);
                if (!is_menu && !is_demo) {
                    // We position since it's not menu
                    this.languagePosition(element, linguise_switcher.language_settings?.display, position);
                }
                has_been_replaced = true;
            });
        }

        const is_cms = linguise_switcher.is_joomla || linguise_switcher.is_wp;

        /**
         * This is the test case:
         * - Not replaced + null position => Append child
         * - Not replaced + `no` position => Append child
         * - Not replaced + other position => Append child
         * - Replaced + null position => Don't append child
         * - Replaced + `no` position => Don't append child
         * - Replaced + other position => Append child
         */
        if (!(has_been_replaced && (position === null || position === 'no'))) {
            if (is_cms && !linguise_switcher.cms_automatic_switcher) {
                // Disabled automatic switcher.
                return;
            }

            const wrapper = document.createElement('div');
            wrapper.className = 'linguise_switcher_wrapper';
            this.replaceAndPaintElement(wrapper, appendedElement, linguise_switcher.language_settings);
            if (!is_demo) {
                this.languagePosition(wrapper, linguise_switcher.language_settings?.display, position);
            }
            document.body.appendChild(wrapper);
        }
    }

    /**
     * Check if there is any element with [linguise] shortcode
     * @param {string} shortcode the shortcode to check
     * @returns {HTMLElement[]}
     */
    findElementWithShortcode(shortcode)
    {
        const elements = document.body.getElementsByTagName('*');

        /** @type {HTMLElement[]} */
        const elementWithShortcode = [];
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].textContent?.trim() === shortcode) {
                elementWithShortcode.push(elements[i]);
            }
        }

        return elementWithShortcode;
    }

    // Check if the switcher is in demo mode
    isDemoMode(linguise_switcher)
    {
        if (linguise_switcher.demo_mode) {
            return true;
        }

        return Boolean(document.getElementById('dashboard-live-preview'));
    }

    /**
     * Try to get Linguise Editor Cookie
     * @returns {Promise<string|null>} - Cookie value or null
     */
    async tryGetLinguiseEditorCookie()
    {
        try {
            const cookie = document.cookie;
            const cookieArray = cookie.split(';');
            for (let i = 0; i < cookieArray.length; i++) {
                const cookieItem = cookieArray[i].split('=');
                if (cookieItem[0].trim() === 'linguiseEditorToken') {
                    return cookieItem[1];
                }
            }
        } catch {
            // use window.cookieStore
            if (window.cookieStore) {
                const cookie = await window.cookieStore.get('linguiseEditorToken');
                return cookie ? cookie.value : null;
            }
        }

        return null;
    }

    /**
     * Get ordered language list, will also keep the default language on top
     * @param {any[]}} available_languages - array of object
     * @param {string} default_language - 2 digit code
     * @param {string[]?} ordered_languages - 2 digit code
     */
    getOrderedLanguageList(available_languages, default_language, ordered_languages)
    {
        if (!ordered_languages) {
            return available_languages;
        }

        const finalized_ordered_languages = [...ordered_languages];

        // check missing languages from ordered_languages
        for (let i = 0; i < available_languages.length; i++) {
            const lang = available_languages[i];
            if (!ordered_languages.includes(lang.code)) {
                finalized_ordered_languages.push(lang.code);
            }
        }

        const reordered_languages = [];

        for (let i = 0; i < finalized_ordered_languages.length; i++) {
            const lang_code = finalized_ordered_languages[i];
            if (lang_code === default_language) {
                continue;
            }

            const lang_data = available_languages.find((item) => item.code === lang_code);

            if (lang_data) {
                reordered_languages.push(lang_data);
            }
        }

        const default_lang = available_languages.find((item) => item.code === default_language);
        if (default_lang) {
            reordered_languages.unshift(default_lang);
        }

        return reordered_languages;
    }


    /**
     * Parse hex color string into RGB object
     * 
     * @param {string} hex hex color string
     * @returns {object} RGB object
     */
    parseHexColor(hex) {
        // Remove the hash symbol if present
        hex = hex.replace('#', '');
        // Check if this shorthand
        if (hex.length === 3) {
            hex = hex.split('').map((char) => char + char).join('');
        } else if (hex.length !== 6) {
            return null;
        }

        hex = hex.toUpperCase();

        // Check if this is a valid hex color
        if (!/^[0-9A-F]{6}$/i.test(hex)) {
            return null;
        }

        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);

        return { r, g, b };
    }

    /**
     * Combine color and alpha transparency
     * @param {string} color hex color string
     * @param {number} alpha float number from 0 to 1
     * @returns {string | null} rgba color string
     */
    mixinColorAndAlpha(color, alpha) {
        if (alpha === 1.0) {
            return color;
        }

        if (color.trim().startsWith('rgba(')) {
            return color;
        }

        if (color.trim().startsWith('rgb(')) {
            // use regex
            const rgb = color.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
            if (!rgb) {
                return null;
            }
            const r = parseInt(rgb[1], 10);
            const g = parseInt(rgb[2], 10);
            const b = parseInt(rgb[3], 10);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }

        const rgb = this.parseHexColor(color);
        if (!rgb) {
            return null;
        }
        const { r, g, b } = rgb;

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    /**
     * Clamp alpha value between 0 and 1
     * @param {number} alpha float number from 0 to 1
     * @returns {number} clamped alpha value
     */
    clampAlpha(alpha) {
        if (alpha < 0) {
            return 0;
        } else if (alpha > 1) {
            return 1;
        }
        return alpha;
    }
}

const helper = new Helper();
export default helper;
